import { ComponentFactoryResolver, Injectable, ViewContainerRef } from '@angular/core';
import { GeneralService } from './general.service';
import { HttpService } from 'src/app/core/http/http.service';
import { AppLoadingService } from './apploading.service';
import { API } from 'src/app/configs';
import { MatDialog } from '@angular/material/dialog';
import html2pdf from 'html2pdf.js';
import { AuthorizationPreviewComponent } from '../components/authorization-preview/authorization-preview.component';
import { FileUpload } from '../utils/fileUpload';
import { Subscription } from 'rxjs';
import { ReasonComponent } from '../components/reason/reason.component';

@Injectable({
    providedIn: 'root'
})
export class RequestAuthorizationService {

    authorizationContinue:any = null;
    pathS3:any = null;

    pdfSubscription: Subscription;

    constructor(
        
        protected httpService: HttpService,
        protected gs: GeneralService,
        protected als: AppLoadingService,
        public dialog: MatDialog,
        private readonly resolver: ComponentFactoryResolver,
        protected fileUpload: FileUpload
    ) {

    }

    async createPDF(contentEl:ViewContainerRef, data, callback): Promise<any> {
        contentEl.clear();
        const factory = this.resolver.resolveComponentFactory(AuthorizationPreviewComponent);
        const componentRef = await contentEl.createComponent(factory);
       
        componentRef.instance.data = data;
    
        componentRef.instance.emitter.subscribe(async (content) => {
          
            const config = {
              
              image:        { 
                type: 'jpeg', 
                quality: 0.98 
              },
              html2canvas: {
                  dpi: 196, 
                  letterRendering: true,
                  scale: 2,
                  scrollX: 0,
                  scrollY: 0,
                  allowTaint: true,
                  useCORS: true,
              },
              jsPDF: { 
                unit: 'mm',
                format: 'a4', 
                orientation: 'portrait'
              }
            };
    
            let file = await this.printPDF(content, config);

            await this.uploadPDF(file, data?.owner, data?.authorization?.person_request_id, callback);
            
            componentRef.destroy();
        });
    }

    printPDF(content: any, config: any) {
        return html2pdf()
            .set(config)
            .from(content,'string')
            .toPdf()
            .outputPdf('blob');
    }

    async uploadPDF(body, person_id, authorization_id, callback){

        this.fileUpload.setDefault();

        this.pdfSubscription = this.gs.filesChangeSubscription$.subscribe(async result => {
          if(result?.files && typeof result?.files[0] !== 'undefined'){
              this.fileUpload.setCallback(null);
              this.pdfSubscription?.unsubscribe();
              callback(result.files[0]);
            }
        });

        
        this.fileUpload.origin = 'person';
        this.fileUpload.ref = authorization_id;
        this.fileUpload.gallery = 'private.person.authorization';
        this.fileUpload.ownerId = person_id;
    
        this.fileUpload.fileEvent(
          [{
            name: 'Autorização.pdf',
            type: body.type,
            size: body.size,
            body: body
          }]);
    }

    async authorize(contentEl, authorization, data, callback){
        await this.als.setLoaded(false, 'authorizationAuthorize');
        await this.createPDF(contentEl, {owner: this.gs.getCompanieSel(), authorization:authorization, authorizeData:data , preview: 'pdf'},async (fileLink)=>{
          console.log(fileLink);
          let file_url = this.gs.getFileUrl(fileLink,fileLink.variations[0].filename);
          let file_id = fileLink?.file_id;
          
          await this.httpService.post<any>(API.person.general.authorization.allow, {
            "ad_id": authorization?.ad_id,
            "owner_person_id": authorization?.owner_person_id,
            "person_request_id": authorization?.person_request_id,
            "update":authorization?.update,
            "expiration_months":data?.expiration?.id,
            "file_url":file_url,
            "file_id":file_id
          })
            .then(async result => {
              
              this.gs.error({}, 'Autorização de venda enviada');
              this.gs.transactionData.next({method:'requestAuthorization', action:'reload'});
              callback();
            })
            .catch((err) => {
              this.gs.error(err);
              callback(err);
            })
            .finally(() => {
              this.als.setLoaded(true, 'authorizationAuthorize');
          });
        });
    }

    async reject(data, callback){
        let modalId = 'ReasonComponent_'+Math.random();
        const dialogRef = this.dialog.open(ReasonComponent, 
        {   disableClose : true,
            id:modalId,
            data: {
              modalId:modalId,
              subtitle : 'Caso não queira justificar a rejeição, deixe o campo vazio'
            }
        });
        dialogRef.afterClosed().subscribe(async result => {
          if(typeof result?.reason != 'undefined'){
            await this.httpService.post<any>(API.person.general.authorization.reject, {
              "owner_person_id": data?.authorization?.owner_person_id,
              "person_request_id": data?.authorization?.person_request_id,
              "update":data?.authorization?.update,
              "message":result.reason
            })
              .then(async result => {
                console.log(result);
                this.gs.error({}, 'Autorização de venda rejeitada');
                this.gs.transactionData.next({method:'requestAuthorization', action:'reload'});
                callback(true);
              })
              .catch((err) => this.gs.error(err))
              .finally(() => {
                this.als.setLoaded(true, 'authorizationAuthorize');
            });
          } else {
            callback(false);
          }
        });
    }

}